import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/** URLs relativas que nao devem ser enviadas para a API (ficam no mesmo origin do app). */
const ASSET_PREFIX = 'assets/';

export const apiBaseInterceptor: HttpInterceptorFn = (req, next) => {
  if (/^https?:\/\//i.test(req.url)) {
    return next(req);
  }

  if (req.url.startsWith(ASSET_PREFIX)) {
    return next(req);
  }

  const normalizedBase = environment.apiUrl.replace(/\/$/, '');
  const normalizedUrl = req.url.startsWith('/') ? req.url : `/${req.url}`;

  return next(
    req.clone({
      url: `${normalizedBase}${normalizedUrl}`,
    })
  );
};
